import React from 'react';
import { ColHeader, ColHeaderText } from './styled';
import { useAtomValue } from 'jotai';
import { percentileAtom } from '@components/metrics-panel-hz/atoms';
import { percentileConfig } from '@utils/metrics/constants';
import { Tooltip, type TooltipProps } from 'antd';
import { getPercentileMetrics } from '@src/utils/metrics/metricHelpers';
export interface MetricHeaderProps {
  column: any;
  helpLookup?: Record<string, React.ReactNode>;
  tooltipProps?: TooltipProps;
}

function MetricHeader({ column, helpLookup = {}, tooltipProps }: MetricHeaderProps) {
  const { metric } = column;
  const metricInfo = column.labelInfo || column.metricInfo;
  const hasHelpLookup = metric in helpLookup;
  const defaultTitle = hasHelpLookup
    ? helpLookup[metric]
    : metricInfo.displayName
      ? `${metricInfo.displayName} ${metricInfo.subscript}`
      : '';

  const percentile = useAtomValue(percentileAtom);

  return (
    <ColHeader>
      <Tooltip placement="top" title={defaultTitle} {...tooltipProps}>
        <ColHeaderText>
          {column.title}{' '}
          {getPercentileMetrics().includes(metric) && `(${percentileConfig[percentile].short})`}
        </ColHeaderText>
      </Tooltip>
    </ColHeader>
  );
}

export default MetricHeader;
